// Polyfill Buffer for browser
import { Buffer } from 'buffer';
(window as any).Buffer = Buffer;
(global as any).Buffer = Buffer;

// Disable browser's automatic scroll restoration - we handle it manually
if ('scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}

import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';
import './i18n/i18n';

createRoot(document.getElementById('root')!).render(<App />);
